import { render } from "./nullData.vue?vue&type=template&id=20726ccc&lang=html"
import script from "./nullData.vue?vue&type=script&lang=js"
export * from "./nullData.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dev2\\Documents\\dev\\sitio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__